<!--小程序 首页推荐品牌 -->
<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="开始日期">
        <el-date-picker
          v-model="queryForm.effectStartTime"
          type="datetime"
          format='yyyy-MM-dd HH:mm:ss'
          value-format='yyyy-MM-dd HH:mm:ss'
          placeholder="选择日期时间"
          :clearable="false"
          >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker
          v-model="queryForm.effectEndTime"
          type="datetime"
          format='yyyy-MM-dd HH:mm:ss'
          value-format='yyyy-MM-dd HH:mm:ss'
          placeholder="选择日期时间"
          :clearable="false"
          >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getProvinceList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetQueryFrom"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="total_count">
      <div class="total_list">数据统计</div>
      <el-tag type="success" size="medium" class="total_list_name"><span>商家总数：</span> {{formatNumberNew(totalCount.allshopnumTotal) }}</el-tag>
      <el-tag type="success" size="medium" class="total_list_name"><span>新增商家数量：</span>{{formatNumberNew(totalCount.newaddshopTotal)}}</el-tag>
      <el-tag type="success" size="medium" class="total_list_name"><span>总业绩：</span> {{formatNumberNew(totalCount.ytotallsTotal)}}</el-tag>
      <el-tag type="success" size="medium" class="total_list_name"><span>可用消费券业绩：</span>{{formatNumberNew(totalCount.yyetotallsTotal)}}</el-tag>
      <el-tag type="success" size="medium" class="total_list_name"><span>现金业绩：</span>{{formatNumberNew(totalCount.ycashtotallsTotal)}}</el-tag>
      <el-tag type="success" size="medium" class="total_list_name"><span>新增用户数量:</span>{{formatNumberNew(totalCount.newusernumTotal)}}</el-tag>
      <el-tag type="success" size="medium" class="total_list_name"><span>用户总数:</span>{{formatNumberNew(totalCount.allusernumTotal)}}</el-tag>
    </div>
    <div class="page-content">
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="dataStatisticsList"
        row-key="id"
        size="small"
        border
        v-loading="loading"
      >
      <el-table-column
          align="center"
          prop="short_name"
          :label="labelShortName"
          width="100"
          min-width="20%"
      >
      </el-table-column>
      <el-table-column
          align="center"
          prop="allshopnum"
          label="商家总数"
          width="150"
           min-width="20%"    
      >
      </el-table-column>
      <el-table-column
          align="center"
          prop="newaddshop"
          label="商家当日新增"
         width="150"
          min-width="20%"
      >
      </el-table-column>
      <el-table-column
          align="center"
          prop="ytotalls"
          label="当日总业绩"
         width="150"
          min-width="20%"
      >
      </el-table-column>
      <el-table-column
          align="center"
          prop="yyetotalls"
          label="当日可用消费业绩"
         width="150"
          min-width="20%"
      >
      </el-table-column>
      <el-table-column
          align="center"
          prop="ycashtotalls"
          label="当日现金业绩"
         width="150"
          min-width="20%"
      >
      </el-table-column>
      <el-table-column
          align="center"
          prop="starttime"
          label="开始时间"
          width="200"
           min-width="20%"
      >
      </el-table-column>
      <el-table-column
          align="center"
          prop="endtime"
          label="结束时间"
          width="200"
           min-width="20%"
      >
      </el-table-column>
      
        <el-table-column
          align="center"
          label="操作"
          min-width="20%"
        >
          <template slot-scope="scop">
             <div >
                  <el-button :type="rangeQueryType"  size="small" @click="regionChange(scop.row.id)">{{ rangeQueryType == 'danger' ? '返回省级数据' : `查看所属${rangeQuery(region)}数据` }}</el-button>
                   <el-button type="primary" style="margin-top: 15px;" size="small" @click="getProvinceList" v-if="rangeQueryType == 'success'">返回省级数据</el-button>
             </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, post, deleteFun, upload} from '@/utils/request.js';
import axios from 'axios';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
    },
  
    data() {
        return {
            value2: 1314,
            title: "增长人数",
            labelShortName:'省/市/区',
            region:'city',//
            rangeQueryType:'warning',
            queryForm:{
              effectStartTime:'',
              effectEndTime:'',
            },
            dataStatisticsList:[],
            loading:false,
            totalCount:
              {
                allshopnumTotal: 0,//店铺总数
                newaddshopTotal: 0,//新增店铺
                ytotallsTotal: 0,//当日总业绩
                yyetotallsTotal: 0, //当日可用消费券总业绩
                ycashtotallsTotal: 0,//当日现金总业绩
                newusernumTotal: 0,//新增用户数量
                allusernumTotal: 0 //用户总数
              }
        };
    },
    created() {
      this.setDefaultYesterdayTime()
      this.getProvinceList()
    },
    methods: {
    setDefaultYesterdayTime() {
      const now = new Date();
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);
      const startOfDay = new Date(yesterday);
      startOfDay.setHours(0, 0, 0, 0);
      const endOfDay = new Date(yesterday);
      endOfDay.setHours(23, 59, 59, 999);
      this.queryForm.effectStartTime = this.formatDateTime(startOfDay);
      this.queryForm.effectEndTime = this.formatDateTime(endOfDay);
    },
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
      formatNumberNew(value){
              if (value === '' || value === null || value === undefined) return '';
                let num = Number(value);
                if (isNaN(num)) return '';
                // 四舍五入到指定小数位数（这里保留2位小数，你可以根据需要调整）
                num = Math.round(num * 100) / 100;
                
                // 转换为字符串
                let numStr = num.toString();
                
                // 处理多个小数点的情况（虽然经过Number转换后应该不会有这个问题）
                const decimalParts = numStr.split('.');
                if (decimalParts.length > 2) {
                  numStr = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`;
                }
                
                // 处理负号不在开头的情况（同样，Number转换后应该不会有这个问题）
                if (numStr.includes('-') && !numStr.startsWith('-')) {
                  numStr = numStr.replace(/-/g, '');
                  numStr = '-' + numStr;
                }
                
                // 分割整数和小数部分
                const parts = numStr.split('.');
                let integerPart = parts[0];
                // 限制小数位数为2位
                const decimalPart = parts.length > 1 ? `.${parts[1].substring(0, 2)}` : '';
                
                // 添加千分位分隔符（跳过负号）
                if (integerPart) {
                  const isNegative = integerPart.startsWith('-');
                  const numWithoutSign = isNegative ? integerPart.slice(1) : integerPart;
                  const formatted = numWithoutSign.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                  integerPart = isNegative ? `-${formatted}` : formatted;
                }
                
                return integerPart + decimalPart;
      },
      refreshDataStatisticsList(){
        this.isSearch = !this.isSearch;
      },
      resetQueryFrom(){
         this.queryForm.effectStartTime = ''
         this.queryForm.effectEndTime = ''
         this.getProvinceList()
      },
      rangeQuery(value){
        let regionName = ''
         switch (value) {
            case 'city':
              regionName = '市级'
              break;
            case 'county':
              regionName = '区/县级'
              break;
            default:
              break;
         }
         return regionName
      },
      //查看数据
      regionChange(id){
          this.totalCount = {
                  allshopnumTotal: 0,
                  newaddshopTotal: 0,
                  ytotallsTotal: 0,
                  yyetotallsTotal: 0,
                  ycashtotallsTotal: 0,
                  newusernumTotal: 0,
                  allusernumTotal: 0
                }
           if(this.region =='city'){
              this.getCityList(id)
              this.rangeQueryType = 'success'
           }else if(this.region =='county'){
              this.getCountyList(id)
              this.rangeQueryType = 'danger'
           }else if(this.region == 'province'){
              this.getProvinceList()
              this.rangeQueryType = 'warning'
           }
      },
      //省份
      getProvinceList(){
          this.totalCount = {
                  allshopnumTotal: 0,
                  newaddshopTotal: 0,
                  ytotallsTotal: 0,
                  yyetotallsTotal: 0,
                  ycashtotallsTotal: 0,
                  newusernumTotal: 0,
                  allusernumTotal: 0
                }
          let obj = {
            starttime:this.queryForm.effectStartTime,
            endtime:this.queryForm.effectEndTime,
          }
          this.loading = true
         axios({
                method: 'get',
                url: 'https://pay.tianelive.com/Query/getpdailydata',
                params: obj,
            }).then((res) => {
                   this.labelShortName = '省份'
                   this.region = 'city'
                   this.rangeQueryType = 'warning'
                   if(res.data.data){
                     this.totalCount.allshopnumTotal += Number(res.data.allshopnum)
                     this.totalCount.newaddshopTotal += Number(res.data.newaddshop)
                     this.totalCount.ytotallsTotal += Number(res.data.ytotalls)
                     this.totalCount.yyetotallsTotal += Number(res.data.yyetotalls)
                     this.totalCount.ycashtotallsTotal += Number(res.data.ycashtotalls)
                     this.totalCount.newusernumTotal += Number(res.data.newusernum)
                     this.totalCount.allusernumTotal += Number(res.data.allusernum)
                     this.dataStatisticsList = res.data.data
                     this.$message.success(res.data.msg);
                     this.loading = false;
                   }
             }) 
      },
      // 获取市列表
      getCityList(id) { 
        this.loading = true;
         axios(
           {
             url: 'https://pay.tianelive.com/Query/getcdailydata',
             method: 'get',
             params: {
               areaId: id,
               starttime:this.queryForm.effectStartTime,
               endtime:this.queryForm.effectEndTime,
             }
           }
         ).then((res) => { 
            this.region = 'county'
            this.labelShortName = '市'
             if(res.data.data){
                     this.totalCount.allshopnumTotal += Number(res.data.allshopnum)
                     this.totalCount.newaddshopTotal += Number(res.data.newaddshop)
                     this.totalCount.ytotallsTotal += Number(res.data.ytotalls)
                     this.totalCount.yyetotallsTotal += Number(res.data.yyetotalls)
                     this.totalCount.ycashtotallsTotal += Number(res.data.ycashtotalls)
                     this.totalCount.newusernumTotal += Number(res.data.newusernum)
                     this.totalCount.allusernumTotal += Number(res.data.allusernum)
                     this.dataStatisticsList = res.data.data
                     this.$message.success(res.data.msg);
                     this.loading = false;
                   }
           
           })
      }, 
      // 获取区县列表 
      getCountyList(id){
        this.loading = true;
        axios(
           {
             url: 'https://pay.tianelive.com/Query/getadailydata',
             method: 'get',
             params: {
               areaId: id,
               starttime:this.queryForm.effectStartTime,
               endtime:this.queryForm.effectEndTime,
             }
           }
         ).then((res) => { 
             this.region = 'province'
             this.labelShortName = '区/县'
             if(res.data.data){
                    this.totalCount.allshopnumTotal += Number(res.data.allshopnum)
                    this.totalCount.newaddshopTotal += Number(res.data.newaddshop)
                    this.totalCount.ytotallsTotal += Number(res.data.ytotalls)
                    this.totalCount.yyetotallsTotal += Number(res.data.yyetotalls)
                    this.totalCount.ycashtotallsTotal += Number(res.data.ycashtotalls)
                    this.totalCount.newusernumTotal += Number(res.data.newusernum)
                    this.totalCount.allusernumTotal += Number(res.data.allusernum)
                    this.dataStatisticsList = res.data.data
                    this.$message.success(res.data.msg);
                    this.loading = false;
                   }
           })
      }
    }
};
</script>

<style lang="scss" scoped>



::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
.total_count{
  background-color: #fff;
  margin-bottom: 10px;
  padding: 15px 20px;
  .total_list{
     font-size: 20px;
     color: #181818;
    
  }
  .total_list_name{
     margin-top: 20px;
     font-size: 17px;
     margin-right: 20px;
     span{
       color: #181818;
     }
  }
}
::v-deep .el-button{
  margin-left: 0 !important;
}
</style>
